import { BounceLoader } from 'react-spinners';

function _Loading() {
    return (
        <div className="w-screen h-screen flex items-center justify-center">
            <BounceLoader color="#3772FF" size={72} />
        </div>
    );
}

export default _Loading;
